export default "__VITE_ASSET__CGx9TZDH__"